<template>
    <el-dialog
  :title="title"
  :visible.sync="dialogVisible"
  width="60%"
  :before-close="handleClose">
  <div class="Dialog">
    <div class="DialogLeft">
        <el-form :label-position="labelPosition" label-width="110px" :model="formLabelAlign" style="width:100%;" >
            <el-form-item label="归属机构">
                <el-cascader
                    :options="InstitutionList"
                    :show-all-levels="false"
                    :props="{ checkStrictly: true }"
                    placeholder="请选择归属机构"
                    @change="ChanInstitution"
                    v-model="InstituVal"
                    size="small"
                    clearable>
                </el-cascader>
            </el-form-item>
            <el-form-item label="归属区域" >
                <el-cascader
                    :options="AreaList"
                    :show-all-levels="false"
                    :props="props"
                    placeholder="请选择归属区域"
                    @change="ChanArea"
                    v-model="AreaVal"
                    size="small"
                    clearable>
                </el-cascader>
            </el-form-item>
            <el-form-item label="机构名称" >
                <el-input v-model="formLabelAlign.name" size="small"></el-input>
            </el-form-item>
            <el-form-item label="机构编码" >
                <el-input v-model="formLabelAlign.code" size="small"></el-input>
                <el-button @click="Detection(formLabelAlign.code)" size="small" v-Jurisdiction="'sys:web:office:manage:checkCode'">检测</el-button>
            </el-form-item>
            <el-form-item label="机构类型" >
                    <el-select  clearable v-model="userTypeVal" placeholder="请选择">
                        <el-option
                        v-for="item in userType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
            </el-form-item>
            <el-form-item label="机构级别" >
                  <el-select  clearable v-model="gradeTypeVal" placeholder="请选择">
                        <el-option
                        v-for="item in gradeType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
            </el-form-item>
        </el-form>
    </div>
    <div class="DialogRight">
        <el-form :label-position="labelPosition" label-width="110px" :model="formLabelAlign" style="width:100%;" >
            <el-form-item label="负责人" >
                <el-input v-model="formLabelAlign.master" size="small"></el-input>
            </el-form-item>
            <el-form-item label="手机号" >
                <el-input v-model="formLabelAlign.phone" size="small"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" >
                <el-input v-model="formLabelAlign.address" size="small"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" >
                <el-input v-model="formLabelAlign.email" size="small"></el-input>
            </el-form-item>
            <el-form-item label="传真" >
                <el-input v-model="formLabelAlign.fax" size="small"></el-input>
            </el-form-item>
            <el-form-item label="备注信息" >
                <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
            </el-form-item>
        </el-form>
    </div>

  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="confirm()">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        title:"标题",
        props:{checkStrictly: true},
        labelPosition:'right',
        formLabelAlign:{},
        AreaList:[],
        AreaVal:"",
        InstitutionList:[],
        InstituVal:"",
        userTypeD:"",
        userTypeVal:"",
        userType:[],
        gradeType:[],
        gradeTypeVal:"",
        parentIds:"",
        parentId:"",
        parList:"",
        
        props: {
          lazy: true,
          lazyLoad:this.Lazy,
           checkStrictly: true
        },
        areaId:"",


      };
    },
    watch:{
      dialogVisible(val){
        if(val != false){
          if(this.title == "修改组织机构"){
          } 
          for(let val of this.userType){
            if(val.label == this.userTypeD){
              this.userTypeVal = val.value
            }
          }
        }
      }
    },
    methods: {
      Lazy(node, resolve){
        const { level } = node;
        setTimeout(() => {
          if(node.level == 1){
            let obj = {
              "parentCode":node.value
            }
             this.$http.post(this.$requestUrl.POST_AREA_LEVEL,obj).then((res) => {
               let data = res.data.data
                    const nodes = data.map((item, index) => ({
                            value: item.areaCode,
                            label: `${item.name}`,
                            leaf:node.level >= 4,
                            id:item.id
                    }));
               resolve(nodes);  

             })
          }else if(node.level == 2){
            let obj = {
              "parentCode":node.value
            }
             this.$http.post(this.$requestUrl.POST_AREA_LEVEL,obj).then((res) => {
               let data = res.data.data
                    const nodes = data.map((item, index) => ({
                            value: item.areaCode,
                            label: `${item.name}`,
                            leaf:node.level >= 4,
                            id:item.id
                    }));
               resolve(nodes);  

             })
          }else{
               let obj = {
              "parentCode":node.value
            }
             this.$http.post(this.$requestUrl.POST_AREA_LEVEL,obj).then((res) => {
               let data = res.data.data
                    const nodes = data.map((item, index) => ({
                            value: item.areaCode,
                            label: `${item.name}`,
                            leaf:node.level >= 4,
                            id:item.id
                    }));
               resolve(nodes);  
             })
          }
        }, 500); 
          },
      handleClose(done) {
        this.dialogVisible = false
      },
      confirm(){
        if(this.title == "添加下级组织机构"){
          let obj = {
            "name":this.formLabelAlign.name,
            "parentId":this.parentId,
            "parentIds":this.parentIds,
            "areaId":this.areaId,
            "code":this.formLabelAlign.code,
            "type":this.userTypeVal,
            "grade":this.gradeTypeVal,
            "master":this.formLabelAlign.master,
            "phone":this.formLabelAlign.phone,
            "address":this.formLabelAlign.address,
            "email":this.formLabelAlign.email,
            "fax":this.formLabelAlign.fax,
            "remarks":this.formLabelAlign.remarks,
          }
          if(obj.name == undefined || obj.name == null || obj.name == ""){
            this.$message({
            type: 'warning',
            message: '请填写机构名称!'
          });
          }else if(obj.code == undefined || obj.code == null || obj.code == ""){
            this.$message({
              type: 'warning',
              message: '请填写机构编码!'
            });
          }else if(obj.type == undefined || obj.type == null || obj.type == ""){
            this.$message({
              type: 'warning',
              message: '请填写机构类型!'
            });
          }else if(obj.grade == undefined || obj.grade == null || obj.grade == ""){
            this.$message({
              type: 'warning',
              message: '请填写机构级别!'
            });
          }else{
            this.$http.post(this.$requestUrl.POST_OFFICE_ADD,obj).then((res) => {
              let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                    this.$message({
                        type: 'success',
                        message:"添加成功"
                    });
                    this.$emit("Visible",false)
              } else {
                this.$message.error(result.msg)
                this.dialogVisible = false
                    this.$emit("Visible",false)
              }
              }).catch(() => {
                 this.dialogVisible = false
                    this.$emit("Visible",false)
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }else if(this.title == "修改组织机构"){
          let obj = {
            "id":this.formLabelAlign.id,
            "name":this.formLabelAlign.name,
            "parentId":this.parentId,
            "parentIds":this.parentIds,
            "areaId":this.areaId,
            "code":this.formLabelAlign.code,
            "type":this.userTypeVal,
            "grade":this.gradeTypeVal,
            "master":this.formLabelAlign.master,
            "phone":this.formLabelAlign.phone,
            "address":this.formLabelAlign.address,
            "email":this.formLabelAlign.email,
            "fax":this.formLabelAlign.fax,
            "remarks":this.formLabelAlign.remarks,
          }
          if(obj.name == undefined || obj.name == null || obj.name == ""){
            this.$message({
            type: 'warning',
            message: '请填写机构名称!'
          });
          }else if(obj.code == undefined || obj.code == null || obj.code == ""){
            this.$message({
              type: 'warning',
              message: '请填写机构编码!'
            });
          }else if(obj.type == undefined || obj.type == null || obj.type == ""){
            this.$message({
              type: 'warning',
              message: '请填写机构类型!'
            });
          }else if(obj.grade == undefined || obj.grade == null || obj.grade == ""){
            this.$message({
              type: 'warning',
              message: '请填写机构级别!'
            });
          }else{
   this.$http.put(this.$requestUrl.PUT_UP_OFFICE,obj).then((res) => {
              let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                    this.$message({
                        type: 'success',
                        message:"修改成功"
                    });
                    this.$emit("Visible",false)
              } else {
                this.$message.error(result.msg)
                this.dialogVisible = false
                    this.$emit("Visible",false)
              }
              }).catch(() => {
                 this.dialogVisible = false
                    this.$emit("Visible",false)
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }

        }
      },
      ChanInstitution(){
        if(this.title == "修改组织机构"){
          let parentId = this.InstituVal[this.InstituVal.length-1]+""
          let parentIds = this.parentIds+this.InstituVal.join(",")+","
          this.parentIds = parentIds
          this.parentId = parentId
        }else{
        this.parList = this.parentIds
        this.parentId = this.InstituVal[this.InstituVal.length-1]+""
        this.parentIds = this.parList+this.parentId+","
        }
      },
      ChanArea(){
        if(this.AreaVal.length == 1){
          for(let val of this.AreaList){
            if(val.areaCode == this.AreaVal[0]){
              this.areaId = val.id
            }
          }
        }else{
            let areaId = this.AreaVal[this.AreaVal.length-2]+""
        let areaIdS = this.AreaVal[this.AreaVal.length-1]
          let obj = {
       "parentCode":areaId
     }
      this.$http.post(this.$requestUrl.POST_AREA_LEVEL,obj).then((res) => {
        if(res.data.code == 200){
          for(let val of res.data.data){
            if(val.areaCode == areaIdS){
              this.areaId = val.id
            }
          }
        }
      })
        }
      },
      Detection(code){ // 检测机构编码
         this.$http.get(this.$requestUrl.GET_OFFICE_CODE+code).then((res) => {
              let result = res.data;
              if (200 === result.code) {
                    this.$message({
                        type: 'success',
                        message:result.msg
                    });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
    },
        serviceType(){ // 机构类型
            let obj = {
              "type": "sys_office_type",
              "delFlag":"0"
            }
            this.$http.post(this.$requestUrl.POST_USER_TYPE,obj).then((res) => {
            let result = res.data;
            if (200 === result.code) {
              this.userType = res.data.data
            }else{
              this.$message.error(result.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
    },
          serviceGrade(){ // 机构等级
            let obj = {
              "type": "sys_office_grade",
              "delFlag":"0"
            }
            this.$http.post(this.$requestUrl.POST_USER_TYPE,obj).then((res) => {
            let result = res.data;
            if (200 === result.code) {
              this.gradeType = res.data.data
            }else{
              this.$message.error(result.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
    },
    },
  mounted() {
    this.serviceType()
    this.serviceGrade()
  }   
  };
</script>
<style>
    .cascader{
        color: black;
    }
    .Dialog{
        display: flex;
        width: 100%;
        height: 100%;
        /* border: 1px solid; */
    }
    .DialogLeft{
        width: 30%;
        height: 100%;
        /* border: 1px solid; */
    }
    .DialogRight{
      width: 30%;
      height: 100%;
      display: flex;
      /* border: 1px solid; */
    }
    .el-cascader-node__label{
        color: #606266;
    }
</style>
